<script>
    let clsPrefix = "sui-cellgroup";
    export let title = "";
</script>

<div class={`${clsPrefix} ${$$props.class || ""}`}>
    {#if title}
        <h4 class={`${clsPrefix}-title`}>{title}</h4>
    {/if}
    <div class={`${clsPrefix}-body`}>
        <slot />
    </div>
</div>

<style lang="less">
    @import './cell.less';
</style>
